import { gql } from '@apollo/client';
export const AUDIT_LOG_FIELDS = gql `
  fragment AuditLogFields on AuditLog {
    id
    sessionId
    requestId
    updatedById
    tableName
    recordId
    updatedAt
    operation
    custom1
    custom2
    custom3
    originalValues
    newValues
    updatedBy {
      id
      firstName
      lastName
    }
  }
`;
export const AUDIT_LOG_RESPONSE_FIELDS = gql `
  ${AUDIT_LOG_FIELDS}

  fragment AuditLogsResponseFields on AuditLogsResponse {
    auditLogs {
      ...AuditLogFields
    }
    employee
    programs
    paymentRequests
    paymentRequestItems
  }
`;
export const GET_AUDIT_LOGS = gql `
  ${AUDIT_LOG_RESPONSE_FIELDS}
  query GET_AUDIT_LOGS($spec: AuditLogsSpec!) {
    getAuditLogs(spec: $spec) {
      ...AuditLogsResponseFields
    }
  }
`;
